module.exports = __webpack_public_path__ + "img/paciente_cita_02.b76c688d.png";